import { Location, DOCUMENT } from '@angular/common';
import { Component, HostBinding, Inject, inject } from "@angular/core";
import {
	Event,
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	Router
} from '@angular/router';

import { InfoBoxService } from "./services/info-box.service";
import { NotificationService } from './services/notification.service';
import { AuthService, ScreenService } from "./services";
import { CounterGroups, LoadingIndicationService } from './services/loading-indication.service';
import { NavbarService } from './core/navigation/navbar/services/navbar.service';
import { NavbarItem } from './core/navigation/navbar/models/navbar-item.model';
import { ScrollService } from './services/scroll.service';

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ['./app.component.scss'],
	preserveWhitespaces: true,
	standalone: false
})
export class AppComponent {

	private _scrollService: ScrollService = inject(ScrollService);

	public onScroll(): void {
		this._scrollService.emitScrollEvent();

	}

	public onScrolledDown(): void {
		this._scrollService.emitscrolledDownEvent();

	}

	public onScrolledUp(): void {
		this._scrollService.emitscrolledUpEvent();

	}

	@HostBinding("class")
	public get getClass() {
		return Object.keys(this.screen.sizes)
			.filter((cl) => this.screen.sizes[cl])
			.join(" ");
	}

	public currentUrl = '';

	showAddTaskPopup = false;

	public selectedItemChanged(navbarItem: NavbarItem) {

		if (navbarItem.id === 23) {
			this.currentUrl = this._location.path();
			this.showAddTaskPopup = true;

			return;
		}

		if (navbarItem) {
			this.router.navigate([navbarItem.path]);
		}
	}

	constructor(
		private _location: Location,
		public infoBoxService: InfoBoxService,
		public loadingIndicationService: LoadingIndicationService,
		private readonly _notificationService: NotificationService,
		public authService: AuthService,
		private screen: ScreenService,
		private router: Router,
		public navbarService: NavbarService,
		@Inject(DOCUMENT) private readonly document: Document
	) {
		this.clearCacheVersion();
		this.startSessionCheck();

		let previouseUrl = "";

		if (this.document?.location?.href != null && this.document.location.href != "login") {
			previouseUrl = this.document.location.href;
			previouseUrl = previouseUrl.replace(document.getElementsByTagName('base')[0].href, "");
			if (previouseUrl != null && previouseUrl != "" && previouseUrl != "login" && !previouseUrl.includes("redirect-access")
				&& !previouseUrl.includes("forgot-password") && !previouseUrl.includes("**")) {
				localStorage.setItem("previouseUrl", previouseUrl);
			}
		}

		// window.addEventListener('storage', (event) => {
		// 	if (!this.authService.WebLinkNotIn(this.router.url) && !this.authService.isLoggedIn) {
		// 		this.router.navigate(['/login']);
		// 	}
		// });


		this.router.events.subscribe(
			(event: Event) => {
				switch (true) {
					case event instanceof NavigationStart:

						this.loadingIndicationService.register(
							{
								groupType: CounterGroups.PAGE_LOAD,
								groupId: null
							},
							"NavigationStart",
							false
						);

						break;
					case event instanceof NavigationEnd:

						this.loadingIndicationService.unregister(
							{
								groupType: CounterGroups.PAGE_LOAD,
								groupId: null
							},
							"NavigationStart",
							false
						);

						break;
					case event instanceof NavigationCancel:

						this.loadingIndicationService.unregister(
							{
								groupType: CounterGroups.PAGE_LOAD,
								groupId: null
							},
							"NavigationStart",
							false
						);

						break;
					case event instanceof NavigationError:

						this.loadingIndicationService.unregister(
							{
								groupType: CounterGroups.PAGE_LOAD,
								groupId: null
							},
							"NavigationStart",
							false
						);

						this._notificationService.error(event.error);

						console.error(event);

						break;
					default: {
						break;
					}
				}
			}
		);

		this.loadAuthentication();
	}

	clearCacheVersion() {
		try {
			const baseElement = this.document.getElementsByTagName('base')[0];
			const cacheVersion = baseElement.getAttribute('data-cache-version') ?? '';
			console.log('Cache version from base tag:', cacheVersion);
			if (cacheVersion != undefined && cacheVersion != null && cacheVersion != '') {
				const storedCacheVersion = localStorage.getItem('cache-version');
				if (storedCacheVersion !== cacheVersion) {
					console.log('Cache version mismatch. Clearing cache...');
					localStorage.clear();
					sessionStorage.clear();
					localStorage.setItem('cache-version', cacheVersion);
				}
				console.log('Stored cache version:', storedCacheVersion);
			}
		} catch (error) {
			console.error('Error clearing cache version:', error);
		}
	}

	loadAuthentication() {
		this.authService.ValidateUserLoginSessionUnsubscribe();
		this.authService.ValidateUserLoginSession();
	}

	private checkInterval = 5000; // Check every 10 seconds

	private startSessionCheck() {
		setInterval(() => {
			const urlTree = this.router.parseUrl(this.router.url);
			const path = urlTree?.root?.children?.['primary']?.segments?.map(segment => segment.path).join('/') ?? '';
			if (!this.authService.WebLinkNotIn(path) && !this.authService.isLoggedIn) {
				window.location.reload();
			}

			if (this.authService.WebLinkNotIn(path) && this.authService.isLoggedIn) {
				this.router.navigateByUrl('/home').then(() => {
					window.location.reload();
				});
			}

		}, this.checkInterval);
	}
}